const faqs = [
  {
    q: 'What is CosplayFans?',
    a: 'CosplayFans.ai is an AI-generated creator platform where fans of cosplay and anime culture interact with original, AI-designed characters. Each creator is built with a unique personality, visual style, and backstory, offering interactive experiences such as live chats, AI-generated images, and VIP access.',
  },
  {
    q: 'What are tokens?',
    a: "Tokens are the platform's digital credits used to access premium features. You can use tokens for live chat interactions, AI image generation, and other exclusive content. Simply purchase a token package, and your balance will be available in your account to spend anytime.",
  },
  {
    q: 'What is Live Chat?',
    a: 'Our Live Chat feature allows you to interact in real time with AI-generated cosplay creators. Each character has a unique personality, tone, and backstory, creating immersive and dynamic conversations.',
  },
  {
    q: 'What is AI Image Generation?',
    a: 'AI Image Generation lets you request custom images of your favorite AI creators in different outfits, poses, and themed settings. Images are generated on demand, giving you fresh, personalized content anytime you want.',
  },
  {
    q: 'What type of content can I find?',
    a: "You'll find a wide range of cosplay and character-themed AI content — interactive chats, custom imagery, VIP-only galleries, and weekly drops from top creators across fantasy, anime, sci-fi, and more.",
  },
  {
    q: 'How can I reach someone with questions?',
    a: 'Head to our Contact Us page or visit the FAQ section. Our support team responds quickly and is happy to help with any questions about tokens, subscriptions, or content.',
  },
  {
    q: 'How do Rewards work?',
    a: 'Rewards run automatically on the tokens you spend. Every token you spend — whether you bought it or earned it — counts toward your lifetime total, which moves you up through 10 levels from Newcomer to Mythic. The moment you reach a new level we instantly credit bonus tokens to your balance. They never expire, and past Mythic you keep earning through endless Prestige levels. You can track your level and bonuses anytime on the Rewards page in My Account.',
  },
  {
    q: 'Is my activity private and discreet?',
    a: 'Your privacy is a top priority. All traffic is protected with industry-standard 256-bit SSL encryption, and your billing statement shows a neutral, discreet descriptor — never CosplayFans — so your purchases stay confidential. We never sell your personal data or share your activity, and you can delete your account and content at any time from your settings.',
  },
]

export default function HomeFAQ() {
  return (
    <section class="cf-section">
      {/* Header — centered */}
      <div class="mb-8 text-center">
        <div class="cf-eyebrow pill mb-4 inline-flex">Got Questions?</div>
        <h2 class="cf-h2">
          Frequently Asked{' '}
          <em class="not-italic text-[var(--cf-cyan)]" style={{ 'font-style': 'italic' }}>
            Questions
          </em>
        </h2>
      </div>

      {/* FAQ — grid with align-items: start so expanded items don't stretch neighbors */}
      <div class="grid grid-cols-1 items-start gap-3 lg:grid-cols-2 lg:gap-4">
        {faqs.map((f) => (
          <details
            class="faq-home-item group overflow-hidden rounded-[14px] transition-colors duration-200"
            style={{
              background: 'rgba(138,43,226,0.04)',
              border: '1.5px solid rgba(138,43,226,0.15)',
            }}
          >
            <summary class="flex cursor-pointer list-none items-center justify-between gap-3.5 px-[22px] py-5 [&::-webkit-details-marker]:hidden">
              <span class="text-[15px] font-bold leading-[1.35] text-[#f0eaeb]">{f.q}</span>
              <span class="flex-shrink-0 text-[22px] font-light text-[var(--cf-primary)] transition-transform duration-200 group-open:rotate-45">
                +
              </span>
            </summary>
            <div class="px-[22px] pb-[22px] text-[14px] leading-[1.7] text-[rgba(255,255,255,0.65)]">
              {f.a}
            </div>
          </details>
        ))}
      </div>

      <style>{`
        .faq-home-item:hover { border-color: rgba(138,43,226,0.3) !important; }
        .faq-home-item[open] {
          background: rgba(138,43,226,0.06) !important;
          border-color: rgba(138,43,226,0.32) !important;
        }
      `}</style>
    </section>
  )
}
